import { ControlValueAccessor, } from '@angular/forms';
import { UiParameterCollectionComponent } from '@components/shared/ui-parameter-collection/ui-parameter-collection.component';
var ProcessIOParametersComponent = /** @class */ (function () {
    function ProcessIOParametersComponent() {
        this.onChange = function () { };
        this.onTouch = function () { };
    }
    Object.defineProperty(ProcessIOParametersComponent.prototype, "isOpen", {
        get: function () {
            return !!this._inputCollection &&
                this._inputCollection.isOpen;
        },
        enumerable: true,
        configurable: true
    });
    ProcessIOParametersComponent.prototype.writeValue = function (value) {
        this.value = value;
        this.onChange(value);
    };
    ProcessIOParametersComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    ProcessIOParametersComponent.prototype.registerOnTouched = function (fn) {
        this.onTouch = fn;
    };
    ProcessIOParametersComponent.prototype.onModelChange = function (value) {
        this.value = value;
        this.onChange(value);
    };
    return ProcessIOParametersComponent;
}());
export { ProcessIOParametersComponent };
